import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import InterfaceHeader from './InterfaceHeader'
import InterfaceNav from './InterfaceNav'
import InterfaceSwitch from './InterfaceSwitch'
import { BannerMessage } from '~/shared/notifications/BannerMessage'

const Interface = () => {
  const synchronizing = useSelector(state => state.sync.synchronizing)
  const me = useSelector(state => state.me)
  const providers = useSelector(state => state.providers)
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <BannerMessage me={me} />
      <InterfaceHeader synchronizing={synchronizing} me={me} providers={providers} />
      <Box sx={{ flex: 1, display: 'flex', overflow: 'auto' }}>
        <InterfaceNav />
        <InterfaceSwitch />
      </Box>
    </Box>
  )
}

export default Interface
